<!-- Toast -->
<p-toast position="top-right"></p-toast>

<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-clipboard"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Filtros -->
<div class="filtros-container">
  <div class="filtros-row">
    <!-- Abas de filtro -->
    <p-selectButton
      [options]="abasOptions"
      [(ngModel)]="abaAtiva"
      optionLabel="label"
      optionValue="value"
      (onChange)="onAbaChange()"
      styleClass="abas-select-button">
    </p-selectButton>

    <!-- Filtro de periodo -->
    <app-periodo-filtro
      modo="avancado"
      [opcoes]="opcoesPeriodo"
      [valorPadrao]="'showAll'"
      [persistir]="true"
      [textoExibicao]="periodoTexto"
      (periodoChanged)="onPeriodoChanged($event)"
      (dialogAberto)="onFiltroPeriodoDialogAberto()"
      (dialogFechado)="onFiltroPeriodoDialogFechado()">
    </app-periodo-filtro>

    <!-- Dropdown de estado -->
    <div class="filtros-extra">
      <p-dropdown
        [options]="estadoFiltroOptions"
        [(ngModel)]="estadoFiltroSelecionado"
        (onChange)="onEstadoFiltroChange()"
        [placeholder]="labels.todos_estados || 'Todos os estados'"
        [showClear]="true"
        optionLabel="label"
        optionValue="value"
        styleClass="estado-dropdown">
        <ng-template let-item pTemplate="item">
          <div class="estado-option-item">
            <i [class]="item.icone" [style.color]="item.cor"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="selectedItem">
          <div class="estado-option-item" *ngIf="item">
            <i [class]="item.icone" [style.color]="item.cor"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Campo de busca -->
    <div class="busca-container">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text"
               pInputText
               [placeholder]="placeholders.buscar_cliente_ou_numero"
               [ngModel]="termoBusca"
               (ngModelChange)="onSearchChange($event)"
               class="busca-input" />
      </span>
    </div>

    <!-- Icone e dropdown formam um bloco unico: a setinha e o modificador do
         campo ao lado e sozinha viraria um "asc/desc" sem referencia. -->
    <div class="ordenacao-container">
      <p-dropdown
        [options]="ordenacaoOptions"
        [(ngModel)]="ordenacaoSelecionada"
        (onChange)="onOrdenacaoChange()"
        [placeholder]="labels.ordenar_por"
        optionLabel="label"
        optionValue="value"
        [pTooltip]="tooltips.ordenacao"
        tooltipPosition="top"
        styleClass="ordenacao-dropdown">
        <ng-template let-item pTemplate="item">
          <div class="ordenacao-option-item">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="selectedItem">
          <div class="ordenacao-option-item" *ngIf="item">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <!-- A direcao vem DEPOIS do campo que ela ordena: le-se "Por ID ↑". -->
      <button pButton
        type="button"
        [icon]="ordenacaoDirecao === 'desc' ? 'pi pi-sort-amount-down' : 'pi pi-sort-amount-up'"
        class="p-button-rounded p-button-text p-button-sm ordenacao-icon"
        (click)="toggleOrdenacao()"
        [pTooltip]="ordenacaoDirecao === 'desc' ? tooltips.ordem_descendente : tooltips.ordem_ascendente"
        [attr.aria-label]="ordenacaoDirecao === 'desc' ? tooltips.ordem_descendente : tooltips.ordem_ascendente"
        tooltipPosition="top">
      </button>
    </div>

    <!-- Toggle de auto-refresh -->
    <div class="auto-refresh-container">
      <button pButton
        type="button"
        [icon]="autoRefreshAtivo ? 'pi pi-sync' : 'pi pi-pause'"
        [pTooltip]="tooltips.auto_refresh"
        tooltipPosition="top"
        [class]="autoRefreshAtivo ? 'p-button-rounded p-button-text p-button-success auto-refresh-btn ativo' : 'p-button-rounded p-button-text p-button-secondary auto-refresh-btn'"
        (click)="toggleAutoRefresh()">
      </button>
      <span class="auto-refresh-status" [class.ativo]="autoRefreshAtivo">
        {{ autoRefreshAtivo ? texts.auto_refresh_ativo : texts.auto_refresh_inativo }}
      </span>
    </div>

  </div>
</div>

<!-- Loading — cards-fantasma no MESMO grid dos cards reais, para que a altura
     ja esteja reservada quando os dados chegarem. Com o spinner centralizado a
     pagina saltava ~414px no momento em que a lista aparecia. -->
<div *ngIf="loading"
     class="pedidos-grid"
     role="status"
     aria-live="polite"
     [attr.aria-label]="texts.carregando">
  <div class="pedido-skeleton" *ngFor="let _ of skeletonSlots" aria-hidden="true">
    <p-skeleton height="42px" borderRadius="0"></p-skeleton>
    <div class="pedido-skeleton-body">
      <p-skeleton width="55%" height="1.1rem"></p-skeleton>
      <p-skeleton width="70%" height="0.8rem"></p-skeleton>
      <p-skeleton width="45%" height="0.8rem"></p-skeleton>
      <p-skeleton width="38%" height="1rem"></p-skeleton>
    </div>
    <div class="pedido-skeleton-footer">
      <p-skeleton shape="circle" size="40px"></p-skeleton>
      <p-skeleton shape="circle" size="40px"></p-skeleton>
    </div>
  </div>
</div>

<!-- Estado de ERRO: precisa vir antes do vazio, senao a falha do servidor se
     disfarca de "voce nao tem pedidos" e o usuario vai mexer no filtro a toa. -->
<div *ngIf="!loading && erroCarregamento" class="estado-erro">
  <i class="pi pi-exclamation-triangle erro-icon" aria-hidden="true"></i>
  <p class="erro-title">{{ texts.erro_carregar_titulo }}</p>
  <p class="erro-subtitle">{{ texts.erro_carregar_subtitulo }}</p>
  <button pButton
          type="button"
          icon="pi pi-refresh"
          [label]="botoes.tentar_novamente"
          (click)="loadPedidos()">
  </button>
</div>

<!-- Empty State — distingue "filtrei e nao achou" de "nao existe pedido ainda" -->
<div *ngIf="!loading && !erroCarregamento && pedidos.length === 0" class="empty-state">
  <i class="pi pi-inbox empty-icon" aria-hidden="true"></i>

  <ng-container *ngIf="temFiltroAtivo(); else semPedidoNenhum">
    <p class="empty-title">{{ texts.nenhum_resultado }}</p>
    <p class="empty-subtitle">{{ texts.ajuste_filtros }}</p>
    <button pButton
            type="button"
            icon="pi pi-filter-slash"
            [label]="botoes.limpar_filtros"
            class="p-button-outlined"
            (click)="limparFiltros()">
    </button>
  </ng-container>

  <ng-template #semPedidoNenhum>
    <p class="empty-title">{{ texts.nenhum_pedido }}</p>
    <p class="empty-subtitle">{{ texts.nenhum_pedido_ainda }}</p>
  </ng-template>
</div>

<!-- Grid de Cards -->
<div *ngIf="!loading && !erroCarregamento && pedidos.length > 0">
  <div class="pedidos-grid">
    <app-pedido-card
      *ngFor="let pedido of pedidos"
      [pedido]="pedido"
      [texts]="{ labels: labels, botoes: botoes, estados: estados, tooltips: tooltips, tipo_entrega: tipo_entrega, origem: origem }"
      [moedaPadrao]="moedaPadrao"
      [localeMoeda]="localeMoeda"
      [digitsMoeda]="digitsMoeda"
      (abrirDetalhe)="onAbrirDetalhe($event)"
      (abrirWhatsApp)="onAbrirWhatsApp($event)"
      (compartilhar)="onCompartilhar($event)"
      (avancarEstado)="onMudarEstado($event)"
      (faturar)="onFaturarDoCard($event)"
      (finalizar)="onFinalizarDoCard($event)"
      (entregar)="onEntregarPedido($event)"
      (abrirEstados)="onAbrirEstadosDoCard($event)">
    </app-pedido-card>
  </div>

  <!-- Paginacao — mesmo padrao das outras 40 telas (ver lista-de-produtos):
       contagem + navegacao a esquerda, "Itens por pagina" a direita. O seletor
       de tamanho sai de dentro do p-paginator e vira dropdown rotulado, senao
       fica um "10" solto sem dizer do que se trata. -->
  <div class="pagination-container">
    <div>
      <p-paginator
        [rows]="itensPorPagina"
        [totalRecords]="totalRegistros"
        [first]="paginaAtual * itensPorPagina"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} de {totalRecords}"
        [showFirstLastIcon]="true">
      </p-paginator>
    </div>
    <div class="flex align-items-center">
      <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
      <p-dropdown
        [options]="pageSizeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="itensPorPagina"
        (ngModelChange)="onRowsPerPageChange()"
        styleClass="w-6rem">
      </p-dropdown>
    </div>
  </div>
</div>

<!-- Dialog de Detalhes -->
<app-pedido-detalhe-dialog
  [visivel]="dialogDetalheVisivel"
  [pedido]="pedidoSelecionado"
  [loading]="loadingDetalhe"
  [texts]="{ texts: texts, labels: labels, botoes: botoes, estados: estados, mensagens: mensagens, tooltips: tooltips }"
  [moedaPadrao]="moedaPadrao"
  [localeMoeda]="localeMoeda"
  [digitsMoeda]="digitsMoeda"
  (visivelChange)="onFecharDetalhe()"
  (mudarEstado)="onMudarEstado($event)"
  (cancelarPedido)="onCancelarPedido($event)"
  (cancelarItem)="onCancelarItem($event)"
  (abrirWhatsApp)="onAbrirWhatsApp($event)"
  (compartilharPedido)="onCompartilhar($event)"
  (faturar)="onFaturar($event)"
  (finalizarPedido)="onFinalizarPedido($event)"
  (entregarPedido)="onEntregarPedido($event)"
  (entregarEFinalizarPedido)="onEntregarEFinalizarPedido($event)"
  (abrirNota)="onAbrirNota($event)"
  (imprimirPedido)="onImprimirPedido($event)"
  (alterarQuantidadeItem)="onAlterarQuantidadeItem($event)"
  (pedidoAtualizado)="onPedidoAtualizado($event)">
</app-pedido-detalhe-dialog>

<!-- Dialog de Confirmacao de Cancelamento (padrao wave — FORM_UI secao 3/4) -->
<p-dialog
  [(visible)]="dialogCancelarVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-times-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ botoes.cancelar_pedido }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmacao_cancelar }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
            [label]="botoes.fechar"
            class="p-button-secondary"
            (click)="dialogCancelarVisivel = false">
    </button>
    <button pButton
            [label]="botoes.confirmar"
            severity="danger"
            icon="pi pi-times-circle"
            (click)="confirmarCancelamento()">
    </button>
  </ng-template>
</p-dialog>

<!-- Seletor de estados aberto pelo ATALHO do card (sem passar pelo detalhe).
     O mesmo componente e usado dentro do pedido-detalhe-dialog. -->
<app-pedido-estados-dialog
  [visivel]="dialogEstadosCardVisivel"
  [pedido]="pedidoParaEstados"
  [texts]="{ botoes: botoes, estados: estados, mensagens: mensagens }"
  (visivelChange)="dialogEstadosCardVisivel = $event"
  (acaoEscolhida)="onAcaoEstadoDoCard($event)">
</app-pedido-estados-dialog>

<!-- Dialog de Imprimir Pedido (v2 — modal, sem navegacao de rota) -->
<app-imprimir-pedido-dialog
  [visible]="dialogImprimirPedidoVisivel"
  [pedidoId]="pedidoParaImprimir?.id ?? null"
  [codigoDePedido]="pedidoParaImprimir?.codigoDePedido"
  (visibleChange)="onImprimirPedidoVisibilidadeChange($event)">
</app-imprimir-pedido-dialog>
